import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

function InfiniteScroll(props) {
  const {
    shouldLoadNewPage,
    handleNewPage,
    children,
  } = props;

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && shouldLoadNewPage) {
      handleNewPage();
    }
  }, [handleNewPage, inView, shouldLoadNewPage]);

  return (
    <>
      {children}
      <div ref={ref} />
    </>
  );
}

export default InfiniteScroll;
